import Vue from 'vue';
import App from './App.vue';
import router from './router';
import storeFactory from './store';
import 'animate.css';
import vuetify from './plugins/vuetify';
Vue.config.productionTip = false;

const store = storeFactory();
new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
